module.exports = ".widget-11{height:100%;position:absolute;left:0;right:0;top:0;bottom:0}.widget-11 .card-body{display:flex;flex-direction:column}\n"